module.exports = __webpack_public_path__ + "3944136333d959ca5fdcbcdb00b7e679.svg";